export const GET_PLANNINGS_PROCESS_LIST = 'orders-plannings-process/GET_PLANNINGS_PROCESS_LIST';
export const getPlanningsProcessListAction = payload => ({
	type: GET_PLANNINGS_PROCESS_LIST,
	payload,
});

export const SET_PLANNINGS_PROCESS_LIST = 'orders-plannings-process/SET_PLANNINGS_PROCESS_LIST';
export const setPlanningsProcessListAction = payload => ({
	type: SET_PLANNINGS_PROCESS_LIST,
	payload,
});

export const SET_IS_PLANNINGS_PROCESS_LIST_LOADING = 'orders-plannings-process/SET_IS_PLANNINGS_PROCESS_LIST_LOADING';
export const setIsPlanningsProcessListLoadingAction = payload => ({
	type: SET_IS_PLANNINGS_PROCESS_LIST_LOADING,
	payload,
});

export const GET_PROCESS_INFO = 'orders-plannings-process/GET_PROCESS_INFO';
export const getProcessInfoAction = payload => ({
	type: GET_PROCESS_INFO,
	payload,
});

export const SET_PROCESS_INFO = 'orders-plannings-process/SET_PROCESS_INFO';
export const setProcessInfoAction = payload => ({
	type: SET_PROCESS_INFO,
	payload,
});

export const SET_IS_PROCESS_INFO_LOADING = 'orders-plannings-process/SET_IS_PROCESS_INFO_LOADING';
export const setIsProcessInfoLoadingAction = payload => ({
	type: SET_IS_PROCESS_INFO_LOADING,
	payload,
});

export const GET_CONFIGS = 'orders-plannings-process/GET_CONFIGS';
export const getConfigsAction = payload => ({
	type: GET_CONFIGS,
	payload,
});

export const SET_CONFIGS = 'orders-plannings-process/SET_CONFIGS';
export const setConfigsAction = payload => ({
	type: SET_CONFIGS,
	payload,
});

export const SET_IS_CONFIGS_LOADING = 'orders-plannings-process/SET_IS_CONFIGS_LOADING';
export const setIsConfigsLoadingAction = payload => ({
	type: SET_IS_CONFIGS_LOADING,
	payload,
});

export const SET_PAGINATION = 'orders-plannings-process/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const SELECT_PLANNING = 'orders-plannings-process/SELECT_PLANNING';
export const selectPlanningAction = payload => ({
	type: SELECT_PLANNING,
	payload,
});

export const SET_IS_PLANNING_SELECTED = 'orders-plannings-process/SET_IS_PLANNING_SELECTED';
export const setIsPlanningSelectedAction = payload => ({
	type: SET_IS_PLANNING_SELECTED,
	payload,
});

export const GET_COLLECTION_LIST = 'orders-plannings-process/GET_COLLECTION_LIST';
export const getCollectionListAction = payload => ({
	type: GET_COLLECTION_LIST,
	payload,
});

export const SET_COLLECTION_LIST = 'orders-plannings-process/SET_COLLECTION_LIST';
export const setCollectionListAction = (id, payload) => ({
	type: SET_COLLECTION_LIST,
	id,
	payload,
});

export const SET_IS_COLLECTION_LIST_LOADING = 'orders-plannings-process/SET_IS_COLLECTION_LIST_LOADING';
export const setIsCollectionListLoadingAction = payload => ({
	type: SET_IS_COLLECTION_LIST_LOADING,
	payload,
});

export const RESET_IS_COLLECTION_LIST_LOADING = 'orders-plannings-process/RESET_IS_COLLECTION_LIST_LOADING';
export const resetIsCollectionListLoadingAction = payload => ({
	type: RESET_IS_COLLECTION_LIST_LOADING,
	payload,
});

export const GET_MODES = 'orders-plannings-process/GET_MODES';
export const getModesAction = payload => ({
	type: GET_MODES,
	payload,
});

export const SET_MODES = 'orders-plannings-process/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'orders-plannings-process/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const SET_PLANNING_OPEN = 'orders-plannings-process/SET_PLANNING_OPEN';
export const setPlanningOpenAction = payload => ({
	type: SET_PLANNING_OPEN,
	payload,
});

export const RESET_STATE = 'orders-plannings-process/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
